<template>
  <div class="chart-container">
    <loading v-if="isLoading" />

    <v-select
      class="year-select"
      :items="anoLectivoAll"
      v-model="anoLectivoSelected"
      @change="carregarDados"
      item-value="descricao"
      item-text="novadescricao"
      label="Ano Lectivo"
      outlined
      dense
      hide-details
    ></v-select>

    <pie-chart v-if="!isLoading && chartData" :chart-data="chartData" :options="chartOptions" />
  </div>
</template>

<script>
import { Pie } from 'vue-chartjs'
import axios from "../../../plugins/axios"
const ls = require('local-storage')

export default {
  components: {
    loading: () => import("../../../components/loading.vue"),
    'pie-chart': {
      extends: Pie,
      props: ['chartData', 'options'],
      mounted() {
        this.renderChart(this.chartData, this.options)
      },
      watch: {
        chartData(newData) {
          this.renderChart(newData, this.options)
        }
      }
    }
  },
  data() {
    return {
      anoLectivoAll: [],
      anoLectivoSelected: ls.get('anolectivo'),
      isLoading: false,
      mediaAll: [],
      chartData: null,
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: true,
          text: 'Média Geral por Sexo'
        },
        legend: {
          position: 'bottom'
        }
      }
    }
  },

  async created() {
    await this.carregarAnosLectivos()
    await this.carregarDados()
  },

  methods: {
    async carregarAnosLectivos() {
      this.isLoading = true
      try {
        const response = await axios.get(`/getAnosLectivosAll`)
        this.anoLectivoAll = response.data
      } catch (error) {
        console.error("Erro ao carregar anos lectivos:", error)
      } finally {
        this.isLoading = false
      }
    },

    async carregarDados() {
      this.isLoading = true
      try {
        const anolectivo = this.anoLectivoSelected || ls.get('anolectivo')
        const response = await axios.get(`/desempenhoPorGenero/${anolectivo}`)
        this.mediaAll = response.data

        this.chartData = {
          labels: this.mediaAll.map(item => item.sexo),
          datasets: [{
            label: 'Média Geral',
            backgroundColor: ['#42A5F5', '#66BB6A', '#FFA726'],
            data: this.mediaAll.map(item => item.media_geral)
          }]
        }
      } catch (error) {
        console.error("Erro ao carregar dados:", error)
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>

<style scoped>
.chart-container {
  margin: 0 auto;
  padding: 20px;
  background-color: #fff;
}
.year-select {
  margin-bottom: 20px;
}
</style>
